export default "__VITE_ASSET__jILts_mj__"